export const formatNumberByThousands = (value: any): any => {
    return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
